import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import RankScore from '../views/RankScore.vue'
import RankActive from '../views/RankActive.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    // 分类积分榜（固定屏）：?venueId=&period=week|month|quarter
    path: '/rank-score',
    name: 'RankScore',
    component: RankScore
  },
  {
    // 在场活跃榜（固定屏）：?venueId=
    path: '/rank-active',
    name: 'RankActive',
    component: RankActive
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
